module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Select a template","gallery":"Gallery","myTemplates":"My Templates","published":"Published"}}')
  delete Component.options._Ctor
}
